module.exports = (status, software, err) => {
  let action = status ? 'Success' : 'Error';
  if (err) {
    action += `|${err}`;
  }
  gtag('event', action, {'event_category': `${software}|EmailForm`, 'event_label': window.location.href, value: ''});
}
